import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllShifts() {
  return (
    <ModulePlaceholderList
      title="Shifts & rosters"
      newPath="/panel/shifts/new"
      newLabel="New shift"
    />
  );
}
